export interface SettingState {
  settings: SettingModel[]
}

export const GET_ALL_SETTINGS = 'GET_ALL_SETTINGS'
export const CREATE_OR_UPDATE_SETTING = 'CREATE_OR_UPDATE_SETTING'
